import ExpertAnswers from '../components/ExpertAnswers';

const EXPERT_ANSWERS_ROUTES = [
  {
    id: 'expert_answers',
    path: '/expert_answers',
    component: ExpertAnswers,
    exact: true
  }
];

export default EXPERT_ANSWERS_ROUTES;
